import commercial from './covers/commercial.svg';
import compliance from './covers/compliance.svg';
import corporate from './covers/corporate.svg';
import data from './covers/data.svg';
import hr from './covers/hr.svg';
import intellectual from './covers/intellectual.svg';
export const getCategoryCover = (type) => {
    switch (type) {
        case 'category:commercial':
            return commercial;
        case 'category:compliance':
            return compliance;
        case 'category:corporate':
            return corporate;
        case 'category:data':
            return data;
        case 'category:hr':
            return hr;
        case 'category:intellectual':
            return intellectual;
        default:
            return '';
    }
};
